import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ["group"]
  images = []
  currentIndex = 0;

  initialize () {
    this.modal = document.getElementById('zoomModal')
    this.image = document.getElementById('zoomModalImage')
  }
  connect() {
    if (!this.hasGroupTarget) return
    window.addEventListener('keydown', this.#navigateImages.bind(this))
  }

  disconnect() {
    if (!this.hasGroupTarget) return
    window.removeEventListener('keydown', this.#navigateImages.bind(this))
  }

  #navigateImages(event) {
    if (event.key === 'ArrowRight')  this.#nextImage()
    else if (event.key === 'ArrowLeft') this.#previousImage()
    else if (event.key === 'Escape') this.close()
  }

  #nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length
    this.#displayImage()
  }

  #previousImage() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    this.#displayImage()
  }

  #displayImage() {
    this.image.src = this.images[this.currentIndex]
  }

  #initIndex(event) {
    if (!this.hasGroupTarget) return
    this.images = []
    const list = event.currentTarget.closest('[data-zoom-modal-target]')
    list.querySelectorAll('[data-image-url]').forEach( button => this.images.push(button.dataset.imageUrl))
    this.currentIndex = this.images.indexOf(event.currentTarget.dataset.imageUrl)
  }

  open (event) {
    this.image.src = event.currentTarget.dataset.imageUrl
    this.modal.toggleAttribute('data-is-hidden', false)
    this.#initIndex(event)
  }

  close () {
    this.image.src = ''
    this.modal.toggleAttribute('data-image-flipped', false)
    this.modal.toggleAttribute('data-image-scaled', false)
    this.modal.toggleAttribute('data-is-hidden', true)
  }

  scale () {
    this.modal.toggleAttribute('data-image-scaled')
  }

  flip () {
    this.modal.toggleAttribute('data-image-flipped')
  }
}
